export const USConstructionTypes = [
    "Type 1 - Fire Resistive",
    "Type 2 - Non-Combustible",
    "Type 3 - Ordinary",
    "Type 4 - Heavy Timber",
    "Type 5 - Wood Framed"
]
